var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"pdf-frame",attrs:{"src":_vm.viewerUrl,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }